import cn from 'classnames';
import { Button, ButtonProps } from 'components/Button';
import styles from './filterButton.scss';

// Used in RD3

type Props = Omit<ButtonProps, 'appearance' | 'border'>;

export const FilterButton = ({ className, ...props }: Props) => (
  <Button {...props} className={cn(styles.button, className)} appearance="tertiary" border="thin" />
);
